import { __rest } from "tslib";
import { createContainer } from 'unstated-next';
import { OverlayContainer } from './overlayContainer';
import { useState, useMemo, useEffect, useCallback } from 'react';
import { adFileSizesArray } from '@ligr/api-v2';
import { useSessionStorage } from '../utils/sessionStorage';
import { DesiredGfxState } from './useGfxState';
const getEntityAdSets = (entity, entityType, entityPercentage = 100) => {
    var _a;
    return (((_a = entity.adAllocation) === null || _a === void 0 ? void 0 : _a.adSets.map(({ adSetAllocations, id, name, adFiles }) => {
        const { percentage = 0, events = [] } = adSetAllocations === null || adSetAllocations === void 0 ? void 0 : adSetAllocations.find(({ entityAdAllocationId }) => { var _a; return entityAdAllocationId === ((_a = entity.adAllocation) === null || _a === void 0 ? void 0 : _a.id); });
        return { percentage: percentage * (entityPercentage / 100), id, name, events, for: entityType, adFiles };
    })) || []);
};
const initialize = (match, foundMetricSummary = undefined, overlay) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const homePercentage = ((_c = (_b = (_a = match === null || match === void 0 ? void 0 : match.competition.adAllocation) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.teams) === null || _c === void 0 ? void 0 : _c.home.enabled) ? (_f = (_e = (_d = match === null || match === void 0 ? void 0 : match.competition.adAllocation) === null || _d === void 0 ? void 0 : _d.config) === null || _e === void 0 ? void 0 : _e.teams) === null || _f === void 0 ? void 0 : _f.home.percentage : 0;
    const awayPercentage = ((_j = (_h = (_g = match === null || match === void 0 ? void 0 : match.competition.adAllocation) === null || _g === void 0 ? void 0 : _g.config) === null || _h === void 0 ? void 0 : _h.teams) === null || _j === void 0 ? void 0 : _j.away.enabled) ? (_m = (_l = (_k = match === null || match === void 0 ? void 0 : match.competition.adAllocation) === null || _k === void 0 ? void 0 : _k.config) === null || _l === void 0 ? void 0 : _l.teams) === null || _m === void 0 ? void 0 : _m.away.percentage : 0;
    const existingAdSetMetrics = (foundMetricSummary === null || foundMetricSummary === void 0 ? void 0 : foundMetricSummary.adSets) || {};
    const existingManualAdsets = (overlay === null || overlay === void 0 ? void 0 : overlay.manualGraphicState) || {};
    const entityAdSets = [
        ...getEntityAdSets(match === null || match === void 0 ? void 0 : match.competition, 'competition', 100 - homePercentage - awayPercentage),
        ...getEntityAdSets(match === null || match === void 0 ? void 0 : match.homeTeam, 'team', homePercentage),
        ...getEntityAdSets(match === null || match === void 0 ? void 0 : match.awayTeam, 'team', awayPercentage)
    ];
    const adSets = entityAdSets.reduce((all, cur) => {
        var _a, _b, _c;
        all[cur.id] = Object.assign(Object.assign({}, cur), { desiredPercentage: (((_a = all[cur.id]) === null || _a === void 0 ? void 0 : _a.desiredPercentage) || 0) + cur.percentage, percentage: 0, percentageLessEvents: 0, msLessEvents: ((_b = foundMetricSummary === null || foundMetricSummary === void 0 ? void 0 : foundMetricSummary.adSets[cur.id]) === null || _b === void 0 ? void 0 : _b.msLessEvents) || 0, ms: ((_c = foundMetricSummary === null || foundMetricSummary === void 0 ? void 0 : foundMetricSummary.adSets[cur.id]) === null || _c === void 0 ? void 0 : _c.ms) || 0, sizes: Object.assign({}, adFileSizesArray.reduce((all, curr) => {
                var _a, _b;
                all[curr] = {
                    ms: ((_a = foundMetricSummary === null || foundMetricSummary === void 0 ? void 0 : foundMetricSummary.adSets[cur.id]) === null || _a === void 0 ? void 0 : _a.sizes[curr].ms) || 0,
                    msLessEvents: ((_b = foundMetricSummary === null || foundMetricSummary === void 0 ? void 0 : foundMetricSummary.adSets[cur.id]) === null || _b === void 0 ? void 0 : _b.sizes[curr].msLessEvents) || 0
                };
                return all;
            }, {})) });
        return all;
    }, {});
    Object.values(existingManualAdsets).forEach(({ adSetId, adSize }) => {
        var _a, _b;
        if (!entityAdSets.find(({ id: entityAdSetId }) => entityAdSetId === adSetId)) {
            adSets[adSetId] = {
                id: adSetId,
                desiredPercentage: 0,
                percentage: 0,
                percentageLessEvents: 0,
                msLessEvents: ((_a = foundMetricSummary === null || foundMetricSummary === void 0 ? void 0 : foundMetricSummary.adSets[adSetId]) === null || _a === void 0 ? void 0 : _a.msLessEvents) || 0,
                ms: ((_b = foundMetricSummary === null || foundMetricSummary === void 0 ? void 0 : foundMetricSummary.adSets[adSetId]) === null || _b === void 0 ? void 0 : _b.ms) || 0,
                sizes: Object.assign({}, adFileSizesArray.reduce((all, curr) => {
                    var _a, _b;
                    all[curr] = {
                        ms: ((_a = foundMetricSummary === null || foundMetricSummary === void 0 ? void 0 : foundMetricSummary.adSets[adSetId]) === null || _a === void 0 ? void 0 : _a.sizes[curr].ms) || 0,
                        msLessEvents: ((_b = foundMetricSummary === null || foundMetricSummary === void 0 ? void 0 : foundMetricSummary.adSets[adSetId]) === null || _b === void 0 ? void 0 : _b.sizes[curr].msLessEvents) || 0
                    };
                    return all;
                }, {}))
            };
        }
    });
    Object.values(existingAdSetMetrics).forEach((_a) => {
        var { id } = _a, rest = __rest(_a, ["id"]);
        if (!entityAdSets.find(({ id: entityAdSetId }) => entityAdSetId === id)) {
            adSets[id] = Object.assign({ id }, rest);
        }
    });
    return {
        adSets,
        unallocatedAdPercentage: (foundMetricSummary === null || foundMetricSummary === void 0 ? void 0 : foundMetricSummary.unallocatedAdPercentage) || 0,
        unallocatedMs: (foundMetricSummary === null || foundMetricSummary === void 0 ? void 0 : foundMetricSummary.unallocatedMs) || 0,
        sizes: Object.assign({}, adFileSizesArray.reduce((all, cur) => {
            all[cur] = {
                ms: (foundMetricSummary === null || foundMetricSummary === void 0 ? void 0 : foundMetricSummary.sizes[cur].ms) || 0,
                msLessEvents: (foundMetricSummary === null || foundMetricSummary === void 0 ? void 0 : foundMetricSummary.sizes[cur].msLessEvents) || 0
            };
            return all;
        }, {}))
    };
};
const randomSort = (_first, _second) => {
    return 0.5 - Math.random();
};
const findEventAdset = (allocation, event) => {
    var _a;
    return (_a = allocation.adSets.find(({ adSetAllocations }) => {
        var _a;
        const current = adSetAllocations === null || adSetAllocations === void 0 ? void 0 : adSetAllocations.find(({ entityAdAllocationId }) => entityAdAllocationId === allocation.id);
        return (_a = current.events) === null || _a === void 0 ? void 0 : _a.find(eventName => eventName.toLowerCase() === event.toLowerCase());
    })) === null || _a === void 0 ? void 0 : _a.id;
};
const findLeastShownSize = (adSizes, adSet, sizes) => {
    var _a, _b;
    const sizeDurations = sizes || {};
    const adFileSizes = ((_a = adSet.adFiles) === null || _a === void 0 ? void 0 : _a.map(({ size }) => size)) || [];
    return (_b = adSizes
        .sort(randomSort)
        .filter(size => adFileSizes.includes(size))
        .map((size) => ({
        size,
        val: sizeDurations[size] || 0
    }))
        // @ts-ignore
        .sort((a, b) => a.val.msLessEvents - b.val.msLessEvents)[0]) === null || _b === void 0 ? void 0 : _b.size;
};
export const AdContainer = () => {
    // based on key store always the data
    const overlayContainer = OverlayContainer.useContainer();
    // The ad container is only rendered if these exist
    const overlay = overlayContainer.overlay;
    const match = overlayContainer.match;
    const { state: { desiredState } } = DesiredGfxState.useContainer();
    const [foundMetricSummary, setSummary] = useSessionStorage(`adMetricsSummary:${overlay.key}`, true);
    // initialize
    const [metricSummary, setMetrics] = useState(initialize(match, foundMetricSummary, overlay));
    useEffect(() => {
        // save in local storage on every change
        setSummary(metricSummary);
    }, [metricSummary]);
    useMemo(() => {
        setMetrics(initialize(match, metricSummary, overlay));
    }, [match === null || match === void 0 ? void 0 : match.competition.adAllocation, match === null || match === void 0 ? void 0 : match.homeTeam.adAllocation, match === null || match === void 0 ? void 0 : match.awayTeam.adAllocation]);
    const updateAdState = (desiredState) => {
        var _a;
        const now = new Date();
        // if no existing date this is the first tracked desired state and contributes zero to the metrics;
        const timeSinceLastChange = now.getTime() - (((_a = metricSummary === null || metricSummary === void 0 ? void 0 : metricSummary.date) === null || _a === void 0 ? void 0 : _a.getTime()) || now.getTime());
        const newMetrics = Object.assign({}, metricSummary);
        if (!metricSummary.currentDesiredState) {
            return setMetrics(Object.assign(Object.assign({}, newMetrics), { currentDesiredState: desiredState, date: now }));
        }
        Object.values(metricSummary.currentDesiredState).forEach(({ adSetId, adSize, eventTrigger, unallocatedAdSlot }) => {
            if (unallocatedAdSlot) {
                newMetrics.unallocatedMs += timeSinceLastChange;
            }
            if (!newMetrics.adSets[adSetId]) {
                return;
            }
            // handle case of event trigger differently
            if (adSetId && adSize) {
                newMetrics.adSets[adSetId].ms = newMetrics.adSets[adSetId].ms + timeSinceLastChange;
                newMetrics.adSets[adSetId].sizes[adSize].ms = newMetrics.adSets[adSetId].sizes[adSize].ms + timeSinceLastChange;
                newMetrics.sizes[adSize].ms = newMetrics.sizes[adSize]
                    ? newMetrics.sizes[adSize].ms + timeSinceLastChange
                    : timeSinceLastChange;
                if (!eventTrigger) {
                    newMetrics.adSets[adSetId].msLessEvents += timeSinceLastChange;
                    newMetrics.adSets[adSetId].sizes[adSize].msLessEvents += timeSinceLastChange;
                    newMetrics.sizes[adSize].msLessEvents = newMetrics.sizes[adSize]
                        ? newMetrics.sizes[adSize].msLessEvents + timeSinceLastChange
                        : timeSinceLastChange;
                }
            }
        });
        const totalDuration = Object.values(newMetrics.adSets).reduce((total, { ms }) => total + ms, 0) + (newMetrics.unallocatedMs || 0);
        const totalDurationWithoutEvents = Object.values(newMetrics.sizes).reduce((total, { msLessEvents }) => total + msLessEvents, 0) +
            (newMetrics.unallocatedMs || 0);
        newMetrics.unallocatedAdPercentage = (newMetrics.unallocatedMs / totalDurationWithoutEvents) * 100;
        Object.entries(newMetrics.adSets).map(([id, adSet]) => {
            adSet.percentage = (adSet.ms / totalDuration) * 100;
            adSet.percentageLessEvents = (adSet.msLessEvents / totalDurationWithoutEvents) * 100;
            // sizes
        });
        Object.entries(newMetrics.sizes).map(([id, size]) => {
            size.percentage = (size.ms / totalDuration) * 100;
            size.percentageLessEvents = (size.msLessEvents / totalDurationWithoutEvents) * 100;
        });
        // search desired state and add
        // const [currentMetrics, prevDate] = metricSummary;
        setMetrics(Object.assign(Object.assign({}, newMetrics), { currentDesiredState: desiredState, date: now }));
        // post update remotely
    };
    useEffect(() => {
        updateAdState(desiredState);
    }, [desiredState]);
    const getNextAd = useCallback(({ adSizes, adSetId, adSetTriggerEvent, teamId }) => {
        var _a, _b;
        let eventTrigger = !!adSetTriggerEvent;
        if (!adSizes) {
            return {
                adSize: undefined,
                adSetId: undefined,
                adUrl: undefined
            };
        }
        const { adSets, sizes } = metricSummary;
        // console.log(adSets, sizes);
        // is Event if event find details based on team, config and all allocations
        if (adSetTriggerEvent) {
            let chosenAdSet;
            const eventConfig = (_b = (_a = match === null || match === void 0 ? void 0 : match.competition.adAllocation) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.events[adSetTriggerEvent];
            switch (eventConfig) {
                case 'competition':
                    chosenAdSet = findEventAdset(match.competition.adAllocation, adSetTriggerEvent);
                    break;
                case 'team':
                    const team = match.homeTeam.id === teamId ? match.homeTeam : match.awayTeam;
                    if (team.adAllocation) {
                        chosenAdSet = findEventAdset(team.adAllocation, adSetTriggerEvent);
                    }
                    break;
                case 'homeOnly':
                    if (teamId === match.homeTeam.id) {
                        if (match.homeTeam.adAllocation) {
                            chosenAdSet = findEventAdset(match.homeTeam.adAllocation, adSetTriggerEvent);
                        }
                    }
                    break;
                case 'usePercentage':
                    eventTrigger = false;
                default:
                    break;
            }
            if (chosenAdSet) {
                const chosenSize = findLeastShownSize(adSizes, adSets[chosenAdSet], sizes);
                if (chosenSize) {
                    return {
                        adSet: chosenAdSet,
                        adSize: chosenSize,
                        adUrl: adSets[chosenAdSet].adFiles.find(({ size }) => size === chosenSize).file.url
                    };
                }
            }
        }
        // find lowest adset allocation that has matching sizes
        const allAdsets = [...Object.values(adSets)].sort(randomSort);
        let usableAdSets = allAdsets;
        if (adSetId) {
            usableAdSets = usableAdSets.filter(({ id }) => id === adSetId);
        }
        let chosenAdSet;
        let chosenAdSize;
        const desiredUnallocated = 100 - allAdsets.reduce((total, { desiredPercentage }) => total + desiredPercentage, 0);
        while (usableAdSets.length && !chosenAdSet) {
            const sortedAdSets = usableAdSets
                .filter(({ adFiles }) => {
                return adFiles === null || adFiles === void 0 ? void 0 : adFiles.find(({ size }) => {
                    if (adSizes === null || adSizes === void 0 ? void 0 : adSizes.includes(size)) {
                        return true;
                    }
                });
            })
                .sort((asA, asB) => {
                return (asA.percentageLessEvents - asA.desiredPercentage - (asB.percentageLessEvents - asB.desiredPercentage));
            });
            const tempChosenAdSet = sortedAdSets[0];
            if (tempChosenAdSet) {
                if (tempChosenAdSet.percentageLessEvents - tempChosenAdSet.desiredPercentage >
                    metricSummary.unallocatedAdPercentage - desiredUnallocated) {
                    return {
                        unallocatedAdSlot: true
                    };
                }
            }
            const tempChosenAdSize = tempChosenAdSet && findLeastShownSize(adSizes, adSets[tempChosenAdSet === null || tempChosenAdSet === void 0 ? void 0 : tempChosenAdSet.id], sizes);
            if (!tempChosenAdSize) {
                usableAdSets = usableAdSets.slice(1);
                continue;
            }
            chosenAdSet = tempChosenAdSet;
            chosenAdSize = tempChosenAdSize;
        }
        if (!chosenAdSet) {
            return;
        }
        return {
            adSetId: chosenAdSet.id,
            adSize: chosenAdSize,
            eventTrigger,
            adUrl: adSets[chosenAdSet.id].adFiles.find(({ size }) => size === chosenAdSize).file.url,
            autoAdSet: !adSetId,
            autoAdSize: adSizes.length > 1
        };
        // handle percentage
        // if not event  sort based on least used campaign relative to overall percentage
    }, [metricSummary]);
    //
    // const reportMetricUpdate =
    return { getNextAd };
};
export const Ads = createContainer(AdContainer);
//# sourceMappingURL=adsContainer.js.map